module.exports = __webpack_public_path__ + "img/hok-60x60.b7f28b4a.png";